// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5m-2";
export var blackBorderOnHover = "_5m-7";
export var cell = "_5m-6";
export var cellContainer = "_5m-3";
export var checked = "_5m-8";
export var disabled = "_5m-5";
export var featuredIconCellContainer = "_5m-9";
export var featuredIconTextContainer = "_5m-b";
export var featuredIconWrapper = "_5m-a";
export var noBorder = "_5m-c";
export var orangeSelectedRow = "_ej-3";
export var overflowableText = "_5m-0";
export var overflowableTextContainer = "_5m-1";
export var row = "_5q-0";
export var rowCheckboxCell = "_5m-4";
export var selectableTable = "_ej-2";